import { SimpleBadge } from '@/components/badges';
import { ColumnDef } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { InviteTableRowType } from '../types';

const InviteRoleHeader: FC = () => {
  const { t } = useTranslation('settings');
  return <>{t('workspaceUsers.columns.role')}</>;
};

export const getInviteRoleColumn = (): ColumnDef<InviteTableRowType> => {
  return {
    accessorKey: 'role',
    header: InviteRoleHeader,
    cell: ({ row }) => (
      <div className='text-sm'>
        <SimpleBadge label={row.original.role} />
      </div>
    ),
  };
};
